<div class="modal-header-modern">
  <div class="modal-header-icon icon-purple">
    <i class="material-icons">description</i>
  </div>
  <div>
    <h4 class="modal-title-modern">{{ formularioId ? 'Editar Formulário' : 'Novo Formulário' }}</h4>
    <p class="modal-subtitle-modern">Configure as perguntas do seu formulário</p>
  </div>
  <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelar()">
    <i class="material-icons">close</i>
  </button>
</div>

<div class="modal-body" *ngIf="!loading">
    <form [formGroup]="formularioForm">
        <!-- Info do formulário -->
        <div class="row mb-4">
            <div class="col-md-8">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Nome do formulário</mat-label>
                    <input matInput formControlName="nome" placeholder="Ex: Anamnese Inicial" maxlength="200">
                </mat-form-field>
            </div>
            <div class="col-md-4 d-flex align-items-center">
                <mat-checkbox formControlName="ativo">Ativo</mat-checkbox>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descrição (opcional)</mat-label>
                    <textarea matInput formControlName="descricao" rows="2" placeholder="Breve descrição do formulário"></textarea>
                </mat-form-field>
            </div>
        </div>

        <!-- Perguntas -->
        <div class="section-card">
          <div class="section-header">
            <i class="material-icons">quiz</i>
            <h4>Perguntas</h4>
            <button type="button" class="btn-modern btn-modern-primary btn-sm ms-auto" (click)="adicionarPergunta()">
                <i class="material-icons">add</i> Adicionar Pergunta
            </button>
          </div>

          <div class="section-body">
            <div *ngIf="perguntas.length === 0" class="empty-perguntas">
                <i class="material-icons">help_outline</i>
                <p>Nenhuma pergunta adicionada ainda.</p>
                <span>Clique em "Adicionar Pergunta" para começar.</span>
            </div>

            <div cdkDropList (cdkDropListDropped)="drop($event)" class="perguntas-list" formArrayName="perguntas">
                <div *ngFor="let pergunta of perguntas.controls; let i = index; trackBy: trackByIndex" cdkDrag class="pergunta-card">
                    <div class="pergunta-card-body" [formGroupName]="i">
                        <div class="pergunta-header">
                            <div class="pergunta-drag-area">
                                <i class="material-icons drag-handle" cdkDragHandle>drag_indicator</i>
                                <span class="pergunta-badge">{{ i + 1 }}</span>
                            </div>
                            <button type="button" class="btn-modern btn-modern-danger btn-sm" (click)="removerPergunta(i)">
                                <i class="material-icons">delete</i>
                            </button>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Texto da pergunta</mat-label>
                                    <input matInput formControlName="texto" placeholder="Ex: Qual sua queixa principal?" maxlength="500">
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Tipo de pergunta</mat-label>
                                    <mat-select formControlName="tipoPergunta">
                                        <mat-option *ngFor="let tipo of tiposPergunta" [value]="tipo.value">
                                            {{ tipo.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2 d-flex align-items-center">
                                <mat-checkbox formControlName="obrigatoria">Obrigatória</mat-checkbox>
                            </div>
                        </div>

                        <!-- Opções para EscolhaUnica/EscolhaMultipla -->
                        <div class="row" *ngIf="precisaOpcoes(getTipoPergunta(i))">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Opções (separadas por vírgula)</mat-label>
                                    <input matInput formControlName="opcoes" placeholder="Ex: Opção 1, Opção 2, Opção 3">
                                    <mat-hint>Separe as opções com vírgula</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Escala min/max -->
                        <div class="row" *ngIf="precisaEscala(getTipoPergunta(i))">
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Valor mínimo</mat-label>
                                    <input matInput type="number" formControlName="escalaMinimo" placeholder="0">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Valor máximo</mat-label>
                                    <input matInput type="number" formControlName="escalaMaximo" placeholder="10">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <ngx-loading [show]="loading"></ngx-loading>
    </form>
</div>

<div class="modal-body text-center" *ngIf="loading">
    <ngx-loading [show]="loading"></ngx-loading>
</div>

<div class="modal-footer-modern">
  <button type="button" class="btn-modern btn-modern-outline" (click)="cancelar()">
    Cancelar
  </button>
  <button type="button" class="btn-modern btn-modern-success" (click)="confirmar()" [disabled]="loading">
    <i class="material-icons">check</i>
    {{ formularioId ? 'Salvar alterações' : 'Criar formulário' }}
  </button>
</div>
